/**
 * 定义了接口返回的相关的状态
 */
export const currStage = {
    /**
     * 订单当前阶段
     *
     * payment:  支付阶段
     * deliver:  发货阶段
     * ticket:   工单阶段
     * postSale: 售后阶段
     */

    PAYMENT: 'payment',

    DELIVER: 'deliver',

    TICKET: 'ticket',

    POSTSALE: 'post_sale'

};
export const payment = {

    /**
     * 订单已经创建等待用户确认支付
     */
    CREATED: 'created',

    /**
     * 用户已确认支付订单
     */
    PROCESSING: 'processing',

    /**
     * 订单已确认收款成功(终止态)
     */
    COMPLETED: 'completed',

    /**
     * 订单被用户取消，或支付超时(终止态)
     */
    CLOSED: 'closed'

};

export const deliver = {
    /**
     * 发货阶段状态
     *
     * pending:       订单等待订阅生效
     * processing:    订阅服务处理中
     * completed:     订阅成功生效(终止态)
     * closed:        订阅取消生效动作(终止态)
     */
    PENDING: 'pending',

    PROCESSING: 'processing',

    COMPLETED: 'completed',

    CLOSED: 'closed'
};

export const ticket = {
    /**
     * 工单阶段状态
     *
     * processing:       订单在 发货阶段 或者 售后阶段 关闭订单之前有工单产生
     * success:          工单成功(终止态)
     * failed:           工单失败(终止态)
     */

    PROCESSING: 'processing',

    SUCCESS: 'success',

    FAILED: 'failed'
};

export const postSale = {
    /**
     * 售后阶段状态
     *
     * ready:            准备进行售后
     * refunding:        退款中
     * closed:           售后关闭(终止态)
     */

    READY: 'ready',

    REFUNDING: 'refunding',

    CLOSED: 'closed'

};

export const plan = {

    ALL: 'all',

    /**
     * 有效套餐
     */
    ENABLED: 'enabled',

    /**
     * 无效套餐
     */
    DISABLED: 'disabled',

    /**
     * 只能续费的套餐（无法新购）
     */
    RENEW_ONLY: 'renew_only'

};
